let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("10Vy1")).then(() => parcelRequire('dxT54'));